export default __webpack_public_path__ + "static/media/by.4be3b88a.svg";